import device from "./device"
import camera from "./camera"
import voice from "./voice"

// https://open.ys7.com/doc/zh/
const baseUrl = "https://open.ys7.com/api/lapp/"

export function get(url, data) {
    return send(baseUrl + url,
        {
            method: 'GET', body: JSON.stringify(data),
            // headers: {
            //     'Content-Type':'application/x-www-form-urlencoded',
            //     'accessToken':accessToken,
            // }
        })
}

export function post(url, data) {
    let dataString = ""
    Object.keys(data).map(key => {
        dataString += dataString ? `&${key}=${data[key]}` : `${key}=${data[key]}`
    })
    return send(baseUrl + url,
        {
            method: 'POST', body: dataString,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        })
}

export function postForm(url, data, form) {
    Object.keys(data).forEach(key => {
        url += key + '=' + data[key] + '&'
    })
    const formData = new FormData()
    Object.keys(form).forEach(key => {
        formData.append(key, form[key])
    })
    return send(baseUrl + url,
        {
            method: 'POST', body: formData,
            headers: {
                // 'Content-Type': 'multipart/form-data;',
            }
        })
}

function send(url, config) {

    return new Promise(resolve =>
        fetch(url, config).then(response => {
            return response.json()
        }).then(({code, msg, page, data}) => {

            if ('200' == code) return resolve(data || page || true)
            console.error('萤石云返回错误', msg, code)


        }).catch(err => {
            console.info("萤石云失败", err);
        }))

}

export default {device, camera, voice}